import $ from 'jquery';
import jQuery from 'jquery';

window.$ = $;
window.jQuery = jQuery;



// WEBPACK FOOTER //
// ./src/util/jquery.js